import type { TSelectOption } from '@oslokommune/punkt-elements'
import { useState } from 'react'

import { PktButton, PktSelect,PktTag } from '@/components'

export default function Select() {
  const options: TSelectOption[] = [
    { value: 'apple', label: 'Apple' },
    { value: 'orange', label: 'Orange' },
    { value: 'grape', label: 'Grape' },
    { value: 'pear', label: 'Pear' },
    { value: 'durian', label: 'Durian' },
  ]

  const [buttonValue, setButtonValue] = useState('🎉')
  const [buttonClickCount, setButtonClickCount] = useState(0)

  const [helptext, setHelptext] = useState('')

  const [stateOptions, setStateOptions] = useState<Array<string>>(['option 1', 'option 2', 'option 3'])
  const [selectedOption, setSelectedOption] = useState<string>('')
  return (
    <>
      <main className="page-main pkt-container">
        <h1>Select</h1>

        <section className="component">
          <PktSelect
            id="testinput1"
            label={'Select (Klikket: ' + buttonClickCount + ' ganger)'}
            defaultValue="Oranges"
            onChange={(e) => console.log(e.target.value)}
            helptext={
              <>
                <PktButton
                  size="small"
                  skin="secondary"
                  onClick={(e) => {
                    setButtonValue('🥳')
                    setButtonClickCount(buttonClickCount + 1)
                  }}
                >
                  {buttonValue}
                </PktButton>
                &nbsp;Dette er tekstfelt med en knapp som kan klikkes på for å endre tekst
              </>
            }
          >
            <option>Frukt…</option>
            <option>Apples</option>
            <option>Oranges</option>
            <option>Grapes</option>
            <option>Pears</option>
            <option>Durians</option>
          </PktSelect>
          <div className="my-size-24">
            <PktButton onClick={() => setHelptext('Dette er en hjelpetekst')}>Sett helptext</PktButton>
            <PktButton onClick={() => setHelptext('')}>Fjern helptext</PktButton>
          </div>
          <PktSelect id="testinput2" label="Select inline" defaultValue={'Pears'} helptext={<>{helptext}</>} inline>
            <option>Frukt…</option>
            <option>Apples</option>
            <option>Oranges</option>
            <option>Grapes</option>
            <option>Pears</option>
            <option>Durians</option>
          </PktSelect>
          <PktSelect id="testinput21" label="Select inline" helptext="Dette er tekst over tekstfeltet" inline>
            <option>Frukt…</option>
            <option>Apples</option>
            <option>Oranges</option>
            <option>Grapes</option>
            <option>Pears</option>
            <option>Durians</option>
          </PktSelect>
          <PktSelect id="testinput3" label="Select med tag" helptext="Dette er tekst over tekstfeltet" requiredTag>
            <option>Frukt…</option>
            <option>Apples</option>
            <option>Oranges</option>
            <option>Grapes</option>
            <option>Pears</option>
            <option>Durians</option>
          </PktSelect>
          <PktSelect id="testinput4" label="Select med tag" helptext="Dette er tekst over tekstfeltet" optionalTag>
            <option>Frukt…</option>
            <option>Apples</option>
            <option>Oranges</option>
            <option>Grapes</option>
            <option>Pears</option>
            <option>Durians</option>
          </PktSelect>
          <PktSelect
            id="testinput5"
            label="Select med tagtekst"
            helptext="Dette er tekst over tekstfeltet"
            tagText="Taggtekst"
          >
            <option>Frukt…</option>
            <option>Apples</option>
            <option>Oranges</option>
            <option>Grapes</option>
            <option>Pears</option>
            <option>Durians</option>
          </PktSelect>
          <PktSelect
            id="testinput9"
            label="Select med error"
            helptext="Dette er tekst over tekstfeltet"
            errorMessage="Dette er en feilmelding"
            hasError
          >
            <option>Frukt…</option>
            <option>Apples</option>
            <option>Oranges</option>
            <option>Grapes</option>
            <option>Pears</option>
            <option>Durians</option>
          </PktSelect>
          <PktSelect
            id="testinput10"
            label="Select med dropdown"
            helptext="Bruk dette tekstfeltet til å skrive en kort varsling."
            helptextDropdown="Dette er teksten i dropdown"
          >
            <option>Frukt…</option>
            <option>Apples</option>
            <option>Oranges</option>
            <option>Grapes</option>
            <option>Pears</option>
            <option>Durians</option>
          </PktSelect>
          <PktSelect
            id="testinput11"
            label="Select disabled"
            helptext="Bruk dette tekstfeltet til å skrive en kort varsling."
            helptextDropdown="Dette er teksten i dropdown"
            disabled
          >
            <option>Frukt…</option>
            <option>Apples</option>
            <option>Oranges</option>
            <option>Grapes</option>
            <option>Pears</option>
            <option>Durians</option>
          </PktSelect>
        </section>
        <section className="component">
          <PktSelect
            id="testinput5"
            label={'Valgt verdi ' + selectedOption}
            value={selectedOption}
            helptext={<PktTag onClick={() => console.log('click')}>Dette er tekst over tekstfeltet</PktTag>}
            onChange={(e) => setSelectedOption(e.target.value)}
          >
            {stateOptions.map((option) => (
              <option key={option} value={option}>
                {option}
              </option>
            ))}
          </PktSelect>
          <PktButton onClick={() => setStateOptions([...stateOptions, 'option ' + (stateOptions.length + 1)])}>
            Add option
          </PktButton>
          <PktButton onClick={() => setStateOptions(stateOptions.slice(0, stateOptions.length - 1))}>
            Remove option
          </PktButton>
          {stateOptions.length > 0 && (
            <PktButton onClick={() => setStateOptions([])} skin="tertiary">
              Clear options
            </PktButton>
          )}
        </section>
      </main>
    </>
  )
}
